import React from 'react'
import './styles'

export default \
class Header extends React.Component
  @displayName: 'Header'

  render: ->
    { children, className='', props... } = @props
    <div className="Header #{className}" {props...} >
      {children}
    </div>
